/**
 * configuration redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    UPDATE_CONFIGURATION, LOAD_USER_SETTINGS, CHANGE_USER_SETTING
} from "./consts";


export const updateConfigurationAction = (configuration) => ({
    type: UPDATE_CONFIGURATION,
    configuration: configuration
});

export const loadUserSettingsAction = (settings) => ({
    type: LOAD_USER_SETTINGS,
    settings: settings
});

export const changeUserSettingAction = (fieldId, value) => ({
    type: CHANGE_USER_SETTING,
    fieldId: fieldId,
    value: value
});
